import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchUserGroups, updateUserGroup, deleteUserGroup } from '../actions/userGroups.actions';
import ListState from '../states/list.state';

const initialState: ListState = {
  loading: false,
  data: [],
  error: null,
  meta: null,
};

const userGroupsSlice = createSlice({
  name: 'userGroups',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserGroups.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserGroups.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchUserGroups.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })
      .addCase(updateUserGroup.fulfilled, (state, action: PayloadAction<any>) => {
        const updatedUserGroup = action.payload;
        const index = state.data.findIndex((userGroup: any) => userGroup.id === updatedUserGroup.id);
        if (index !== -1) {
          state.data[index] = updatedUserGroup;
        }
      })
      .addCase(deleteUserGroup.fulfilled, (state, action: PayloadAction<any>) => {
        const deletedId = action.payload;
        state.data = state.data.filter((userGroup: any) => userGroup.id !== deletedId);
      });
  },
});

export default userGroupsSlice.reducer;